<ngx-loading [show]="isProcessing"></ngx-loading>

<div class="row">

  <div class="col-md-12">

    <div class="box box-primary">

      <div class="box-header text-center">
        <h3 class="box-title ">Calendário Mensal Preventivas</h3><br />
      </div>
      <div class="divider mt-0"></div>

      <div class="box-body">

        <form novalidate [formGroup]="form" id="form" (validSubmit)="submit()">
          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="nome">Mês/Ano</label>
                <input class="form-control text-center" type="text" formControlName="mesano"
                  [textMask]="{mask: maskMesAno, guide: true}" (change)="changeMesAno()" />
                <small *ngIf="form.get('mesano').hasError('isInvalidMesano')" class="form-text text-danger pl-2">
                  Mês/Ano inválido
                </small>

              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="areaTecnicaId">Área técnica</label>
                <select class="form-control" formControlName="areaTecnicaId">
                  <option value="0">Todas as áreas técnicas</option>
                  <option *ngFor="let t of areasTecnicas" [value]="t.id">{{ t.nome }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">&nbsp;</label>
              <button type="submit" class="btn btn-primary btn-block btn-shadow" title="Pesquisar"><i
                  class="fa fa-search"></i></button>
            </div>
            <div class="col-md-1">
              <label for="">&nbsp;</label>
              <button type="button" class="btn btn-secondary btn-block btn-shadow" (click)="reset()"
                title="Limpar pesquisa"><i class="fa fa-trash"></i></button>
            </div>
          </div>

        </form>
      </div>
    </div>

  </div>

</div>

<div class="row">

  <div class="col-md-12">

    <div class="box box-primary">

      <div class="box-body">


        <div class="box-header text-center">
          <h3 class="box-title ">Resultado da pesquisa</h3><br />
        </div>

        <div class="box-body h350">

          <div class="box-table h300">
            <table class="table-striped">
              <thead>
                <tr>
                  <th class="text-center">Foto antes</th>
                  <th class="text-center">Classe equipamento</th>
                  <th class="text-center">Tipo equipamento</th>
                  <th class="text-center">Código</th>
                  <th class="text-center">Descrição</th>
                  <th class="text-center">Rotina</th>
                  <th class="text-center">Periodicidade</th>
                  <th class="text-center">Próxima execução</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rp of resultadosPesquisa">
                  <td class="text-center cp" (click)="showAtividade(rp.atividadeId, modalFotoAntes)">
                    <span class="fa fa-camera"
                      [ngClass]="{'txt-green': rp?.uploadPhotos?.length > 0, 'txt-blue': rp?.uploadPhotos?.length == 0}">
                    </span>
                    <sup *ngIf="rp?.uploadPhotos?.length > 0" class="txt-green fb">
                       {{rp?.uploadPhotos?.length}} 
                    </sup>
                  </td>
                  <td>{{rp.classeEquipamento}}</td>
                  <td>{{rp.tipoEquipamento}}</td>
                  <td>{{rp.codigo}}</td>
                  <td>{{rp.descricao}}</td>
                  <td>{{rp.rotina}}</td>
                  <td class="text-center">{{rp.periodicidade}}</td>
                  <td class="text-center">{{rp.proximaExecucao | date: 'dd/MM/yyyy'}}</td>

                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-left mt-2">
            <span class="pl-1">Total: <b>{{ this.resultadosPesquisa?.length }}</b> </span>

          </div>
        </div>
      </div>
    </div>
  </div>

</div>



<div class="row mt-1">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-5">

            <section *ngIf="excelFileName !== ''" [class.highlight]="excelFileName !== ''">
              <div class="col-md-4 text-center" >
                <a *ngIf="excelFileName !== ''" [href]="hrefExcelFile" >{{excelFileName}}</a>  
              </div>
            </section>

          </div>
         
          <div class="col-md-3">
            <button type="button" class="btn btn-primary btn-block btn-shadow" 
            [disabled]="this.form.invalid || !this.autorizacoes?.podeListar || this.resultadosPesquisa.length == 0" 
            (click)="exportarToExcel()">
              Exportar Calendário </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>




<ng-template #modalFotoAntes let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Foto antes</h4>
  </div>
  <div class="modal-body pt-0 mt-0 tarja-edit">

    <div class="row mt-3 h600">

      <div class="col-md-1 box-left">
          <span class="fa fa-camera" style="font-size: 3em !important; color: #3c5979"></span>
      </div>

      <div class="col-md-11">


        <div class="bx-tb-default-t1" style="min-height: 300px; ">
          <table class="table table-bordered" *ngIf="this.atividadeSelecionada">
            <tbody class="tbody-default table-atividade">
              <tr>
                <th>Classe equipamento</th>
                <td>{{this.atividadeSelecionada?.classeEquipamento }}</td>
              </tr>
              <tr>
                <th>Tipo equipamento</th>
                <td>{{this.atividadeSelecionada?.tipoEquipamento}}</td>
              </tr>
              <tr>
                <th>Código</th>
                <td>{{this.atividadeSelecionada?.codigo}}</td>
              </tr>
              <tr>
                <th>Descrição</th>
                <td>{{this.atividadeSelecionada?.descricao}}</td>
              </tr>
              <tr>
                <th>Rotina</th>
                <td>{{this.atividadeSelecionada?.rotina}}</td>
              </tr>
              <tr>
                <th>Periodicidade</th>
                <td>{{this.atividadeSelecionada?.periodicidade}}</td>
              </tr>
              <tr>
                <th>Proxima execução</th>
                <td>{{this.atividadeSelecionada?.proximaExecucao | date: 'dd/MM/yyyy'}}</td>
              </tr>


            </tbody>
          </table>
        </div>

        <div class="divider mb-0"></div>

        <section style="border: 1px solid #ddd;">
          <div class="form-row text-center" style="padding: 0 5px;">
            <div class="col-md-11 fb fs11" style="background-color: #eee; padding: 12px">
              <i *ngIf="this.isLoadingRegistroFotografico" class="fa fa-spinner fa-spin fa-fw pull-left"></i>
              Registro fotográfico
            </div>
            <div class="col-md-1 bg-primary cp" style="padding: 12px" title="Adicionar Registro Fotográfico"
              (click)="fileInput.click()">
              <span><i class="fwn fa fa-plus"></i></span>
            </div>

          </div>

          <div class="row showImagens" style="padding-bottom: 20px; min-height: 150px;">
            <div class="col-md-2" *ngFor="let pview of previewsPhotos">
              <div>
                <img [src]="pview.dataUrl" class="zoom cp" (click)="openModalExibePhoto(modalExibePhoto, pview)">
                <button type="button" class="btn btn-default">
                  <i class="fa fa-trash text-secoundary" (click)="removerPhoto(pview.name)"
                    title="Remover esta foto"></i>
                </button>
              </div>
            </div>
          </div>


          <form hidden novalidate [formGroup]="photoForm">
            <input #fileInput formControlName="photo" type="file" accept="image/*" multiple
              (change)="handleFile($event.target.files)">
          </form>

        </section>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <div class="col-md-9"></div>
    <div class="col-md-3">
      <button type="button" class="btn btn-light btn-block" (click)="c('Close click')">Retornar</button>
    </div>
  </div>
</ng-template>


<ng-template #modalExibePhoto let-c="close" let-d="dismiss">
  <div class="modal-body" style="padding: 0px; background-color: #141518;">
    <div class="row">
      <div class="col-md-12 text-center" style="padding:10px; background: #141518 ;">
        <img [src]="previewPhotoSelecionada.dataUrl" class="img-thumbnail">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="padding:10px; background: #141518 ;">
      <div class="text-right">
        <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">Fechar</button>
      </div>
    </div>
  </div>
</ng-template>